import $ from 'jquery';
/**
 * Remember state of alerts by storing a local storage key
 * Can be used for alerts/banners that should be shown until the user removes them manually.
 * Make sure to add the "hidden" class by default
 * A "key" data attribute is also required which used as a name for the local storage entry.
 * Usage example:
 * <div class="alert alert-info alert-dismissible hidden remember-state" data-key="acquirement-info" role="alert">
 *   My alert is very important
 * </div>
 */
function initRememberedAlerts() {
  $('.alert.remember-state').each(function () {
    const $this = $(this);
    const key = $this.data('key');
    if (localStorage.getItem(key) === null) {
      $this.toggleClass('hidden', false);
      $this.show();
    } else {
      $this.remove();
    }

    $('.close').on('click', function () {
      localStorage.setItem(key, 'seen');
    });
  });
}

export { initRememberedAlerts };
